import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import AnnouncementBar from './AnnouncementBar';
import Navbar from './Navbar';
import Footer from './Footer';
import BecomeAuthorModal from '../account/BecomeAuthorModal';
import { useAuthStore } from '../../context/useAuthStore';

export default function Layout() {
  const { pathname } = useLocation();
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const [showAuthorModal, setShowAuthorModal] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);

  useEffect(() => {
    const open = () => setShowAuthorModal(true);
    window.addEventListener('open-become-author-modal', open);
    return () => window.removeEventListener('open-become-author-modal', open);
  }, []);

  return (
    <div className="flex min-h-screen flex-col">
      <AnnouncementBar />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <BecomeAuthorModal
        open={showAuthorModal}
        onClose={() => setShowAuthorModal(false)}
        onConfirmed={(updatedUser) => {
          setUser({ ...user, ...updatedUser });
          setShowAuthorModal(false);
        }}
      />
    </div>
  );
}
